import React from "react";
import PropTypes from "prop-types";
import FdcOverviewtable from "./FdcOveriewtable";

const SmartSourceLensOverviewTable = ({
  data = [],
  columns = [],
  paginationData = {},
  sortingData = {},
  handlePageChange = () => {},
  isLoading = false,
  activeTab = "",
}) => {
  let scrollableColumnsArray = [];

  if (activeTab === "CBU-Source") {
    scrollableColumnsArray = [
      "Allocation At Source",
      "NR to PDQ Mitigation (%)",
      "NR to PDQ Mitigation (Value)",
      "NR to PDQ Mitigation (Volume)",
      "Net Requirement",
      "Order Loss Value",
      "Order Loss Volume",
      "PDQ at Destination",
      "Stock Details Volume (Immediate Source)",
      "Stock Shortfall",
      "Value (Immediate Source)",
      "NR Loss components",
    ];
  } else if (activeTab === "Production Plan") {
    scrollableColumnsArray = [
      "Order Details Volume",
      "Order Details Value",
      "Priority Ranking",
      "Production Plan",
      "Stock Details",
      "Net Requirement",
      "NR Loss components",
      "Action Production Qty (Volume)",
      "Action Production Qty (Value)",
      "Recommended Production plan for next week",
      "Recommendation DBNR",
      "Tag"
    ];
  } else if (activeTab === "Manual Indent") {
    scrollableColumnsArray = [
      "Order Details Value",
      "Order Details Volume",
      "Priority Ranking",
      "Net Requirement",
      "NR Loss components",
      "Factory Stock",
      "Stock Dispatch details(Volume)",
      "Stock Dispatch details(Value)",
    ];
  } else if (activeTab === "Quality Pending") {
    scrollableColumnsArray = [
      "Inspection Start Date",
      "Inspection Start Time",
      "Inspection End Date",
      "Inspection End Time",
      "Inspection Lot Quantity",
      "Accepted Quantity",
      "Rejected Quantity",
      "Pending Quantity",
      "Blocked Quantity",
      "UD Code Date Inspection End Date",
      "UD Recorded At Inspection End Time",
      "Inspection End",
      "Actual QC Clearance Time",
      "QC Time",
      "Average QC Time in Hours (Past 1 Year)",
      "Median QC Time in Hours (Past 1 Year)",
      "Quality Expected Date and Time Of Completion",
      "Delayed Or Not",
      "Status"
    ];
  } else if (activeTab === "CBU-DC-Source") {
    scrollableColumnsArray = [
      "Order Loss Volume",
      "Order Loss Value",
      "Order Loss NR Sufficiency",
      "NR Propogation Loss",
      "Net Requirements",
      "Allocation",
      "PDQ",
      "NR Loss Component %",
      "NR Loss Component (Volume)"
    ];
  }

  return (
    <FdcOverviewtable
      data={data}
      columns={columns}
      paginationData={paginationData}
      sortingData={sortingData}
      handlePageChange={handlePageChange}
      isLoading={isLoading}
      scrollableColumnsArray={scrollableColumnsArray}
      fixedColumnName={columns?.[0]?.label}
      totalColumnName={columns?.[0]?.label}
      tableType="Smart Source Lens"
    />
  );
};

SmartSourceLensOverviewTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
    }),
  ),
  paginationData: PropTypes.shape({
    page: PropTypes.number,
    pageSize: PropTypes.number,
    totalRecords: PropTypes.number,
    totalPages: PropTypes.number,
  }),
  sortingData: PropTypes.shape({
    sortBy: PropTypes.string,
    sortOrder: PropTypes.string,
  }),
  handlePageChange: PropTypes.func,
  isLoading: PropTypes.bool,
  activeTab: PropTypes.string,
};

export default SmartSourceLensOverviewTable;
